// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_s4-0";